module.exports = __webpack_public_path__ + "static/media/jb.06d206d7.jpg";